// extracted by mini-css-extract-plugin
export var result = "ticket-office-search-results-module--result--cd080";
export var results = "ticket-office-search-results-module--results--aa8f7";